import ReactLoadingSkeleton from 'react-loading-skeleton';

import styles from './Skeleton.module.css';

interface Props {
  className?: string;
}

export function Skeleton(props: Props) {
  const { className } = props;
  return (
    <ReactLoadingSkeleton
      className={`${styles['loading-skeleton']} ${className}`}
    />
  );
}
